module.exports = __webpack_public_path__ + "static/media/section2bg.a232455d.png";